import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCSwitch } from '@reverbdotcom/cadence/components';

export interface IProps {
  isOptedOut: boolean;
}

export default function SellingPoliciesPhotoRelistToggle({ isOptedOut }: IProps) {
  const [optIn, setOptIn] = useState(!isOptedOut);

  function handleToggle() {
    const newOptIn = !optIn;
    setOptIn(newOptIn);
  }

  return (
    <>
      <RCSwitch
        checked={optIn}
        onChange={handleToggle}
        label={I18n.t('discovery.shopSettings.photoRelistPolicy.label')}
      />
      <div className="mt-2">
        <p className="form-section__description">
          {I18n.t('discovery.shopSettings.photoRelistPolicy.description')}
        </p>
      </div>
      <input
        name="shop_policies_form[shop][opt_out_photo_relist]"
        id="shop_policies_form_opt_out_photo_relist"
        type="hidden"
        value={optIn ? '0' : '1'}
      />
    </>
  );
}
